import { IValidate } from "../../interfaces/IValidate";
import { IValidationProperties } from "../../interfaces/IValidationProperties";
import { ValidationResultEnum } from "../enums/ValidationResult";
import { inputResult } from "../helpers/inputResult";
import { ValidationResult } from "../helpers/ValidationResult";
import { BaseValidator } from "./BaseValidator";

export class CurrencyValidator extends BaseValidator implements IValidate {

    constructor(validationProperties: IValidationProperties) {
        super(validationProperties);
    }

    validate(value): inputResult {
        if (this.validationProperties.isRequired && !value.length) {
            return this.handle({ inputResult: { error: "Field is required", value: (value || "") }, validationResult: ValidationResultEnum.FieldIsRequired });
        }

        let hasExceededMaxValue = this.validationProperties.max != null && +value > this.validationProperties.max;
        if (hasExceededMaxValue) {
            return this.handle({ inputResult: { error: `Value is greater than maximum (${this.validationProperties.max})`, value: (value || "") }, validationResult: ValidationResultEnum.MaximumNumberExceeded });
        }

        let hasExceededMinValue = this.validationProperties.min != null && +value < this.validationProperties.min;
        if (hasExceededMinValue) {
            return this.handle( { inputResult: { error: `Value is less than minimum (${this.validationProperties.min})`, value: (value || "") }, validationResult: ValidationResultEnum.MinimumExceeded });
        }

        // return super.validate(value);
        return this.handle({ inputResult: { error: "", value: (value || "") }, validationResult: ValidationResultEnum.SuccessFull });
    }

    handle(result: ValidationResult): inputResult {
        // switch (result.validationResult) {
        //     case ValidationResultEnum.MaximumNumberExceeded: {
        //         return { ...result.inputResult, value: this.validationProperties.max }
        //     }
        //     case ValidationResultEnum.MinimumExceeded: {
        //         return { ...result.inputResult, value: this.validationProperties.min }
        //     }
        //     default: {
        //         return result.inputResult;
        //     }
        // }
        return result.inputResult;
    }
}